export default "__VITE_ASSET__5216d3ae__"